import type { PagePath } from "@/config/site";

/** Fallback SEO copy for pages without dedicated i18n meta. */
export const PAGE_SEO: Record<
  Exclude<PagePath, "">,
  { title: string; description: string }
> = {
  "/privacy-policy": {
    title: "Privacy Policy — WasOK",
    description:
      "How WasOK handles product data, local storage, backups, and third-party services.",
  },
  "/terms-of-service": {
    title: "Terms of Service — WasOK",
    description:
      "Terms and conditions for using the WasOK app and website.",
  },
  "/faq": {
    title: "FAQ — WasOK",
    description:
      "Answers to common questions about WasOK, scanning products, privacy, and ratings.",
  },
  "/support": {
    title: "Support — WasOK",
    description:
      "Get help with WasOK: contact support, report bugs, and share feedback.",
  },
  "/licenses": {
    title: "Open Source Licenses — WasOK",
    description:
      "Open-source packages and licenses used by the WasOK mobile app.",
  },
  "/advertising": {
    title: "Advertising — WasOK",
    description:
      "How WasOK approaches advertising and monetization.",
  },
};
